import { render, staticRenderFns } from "./ExtensionManager.vue?vue&type=template&id=77e8aedf&scoped=true&"
import script from "./ExtensionManager.vue?vue&type=script&lang=js&"
export * from "./ExtensionManager.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionManager.vue?vue&type=style&index=0&id=77e8aedf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e8aedf",
  null
  
)

export default component.exports